<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light hidden-pc p-0">
      <div
        class="container-fluid"
        style="
          z-index: 99;
          box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
          border: 1px solid rgba(0, 0, 0, 0.1);
          background-color: #000c50;
        "
      >
        <div class="text-center" style="color: #fff" id="navbarExample01">
          <b>© 2021</b>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
export default {
  components: {},
  props: {},
  computed: {},
  mounted() {},
  data() {
    return {};
  },
  methods: {},
};
</script>
<style>
</style>
